import { withDevtools } from "@angular-architects/ngrx-toolkit";
import { effect, inject } from "@angular/core";
import { getState, patchState, signalStore, withHooks, withMethods, withState } from "@ngrx/signals";
import { LocalStorageService, StateKey } from "../shared/services/local-storage.service";
import { FormulaireState } from "./state";

function createDefaultState(): FormulaireState {
    return {
        reponses: {}
    };
}

// eslint-disable-next-line @typescript-eslint/typedef
export const formulaireStore = signalStore(
    { providedIn: "root" },

    withDevtools("debug"),

    withState(createDefaultState()),

    withMethods((store) => ({
        unsetSimulation(): void {
            patchState(store, () => createDefaultState());
        },

        retrieveState(savedState: any): void {
            patchState(store, () => savedState ?? createDefaultState());
        },

        setReponses(codeFormulaire: string, reponses: any): void {
            patchState(store, () => ({
                reponses: {
                    ...store.reponses(),
                    [codeFormulaire]: reponses
                }
            }));
        }
    })),

    withHooks((store) => {
        // eslint-disable-next-line @typescript-eslint/typedef
        const localStorageService = inject(LocalStorageService);

        return {
            onInit() {
                // eslint-disable-next-line @typescript-eslint/typedef
                const state = localStorageService.getSavedState<FormulaireState>(StateKey.FORMULAIRES);
                if (state) store.retrieveState(state);
                effect(() => {
                    const state: FormulaireState = getState(store);
                    localStorageService.saveState(StateKey.FORMULAIRES, state);
                });
            }
        };
    })
);
